import { GoogleMapProps } from '@react-google-maps/api'

import config from 'constants/config'

// ToDo: Perhaps we should find where the user is and center the map to there, the following are the lat, long for Aus
export const DEFAULT_MAP_GEO = { lat: 25.2744, lng: 133.7751 }
export const DEFAULT_MAP_ZOOM = 2
export const FIT_BOUNDS_PADDING = { top: 77, left: 60, bottom: 40, right: 60 }
export const USER_ZOOM = {
  min: 2,
  max: 20,
}

export const DEFAULT_MAP_OPTIONS: NonNullable<GoogleMapProps['options']> = {
  gestureHandling: 'greedy',
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  zoomControl: false, // Zoom control handled in map component
  minZoom: DEFAULT_MAP_ZOOM,
  maxZoom: 15,
  restriction: {
    latLngBounds: {
      north: 85,
      south: -85,
      west: -180,
      east: 180,
    },
  },
  mapId: config.TRIP_PLANNER_GOOGLE_MAP_ID,
}
